<template>
  <div
    class="progress-bar"
    :class="{border:border,mtLg:mtLg}"
  >
    <div class="progress-bar-title">
      <p>{{ title }}<span>{{ currentValue }}<span>/{{ totalValue }}</span></span></p>
      <p class="small">
        {{ completeText }} {{ completeProgress }}%
      </p>
    </div>
    <div
      class="c-progress-bar"
      :class="isLoading"
      role="progressbar"
      :aria-valuenow="currentValue"
      aria-valuemin="0"
      :aria-valuemax="totalValue"
    >
      <div class="c-progress-bar__indicator">
        <div
          class="c-progress-bar__indicator-value"
          :style="progress"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ProgressBar",
  props: {
    currentValue: {
      type: Number,
      default: 0,
    },
    totalValue: {
      type: Number,
      default: 0,
    },
    border: {
      type: Boolean,
      default: false,
    },
    mtLg: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default() {
        return this.$t("待辦事項");
      },
    },
    completeText: {
      type: String,
      default() {
        return this.$t("完成");
      },
    },
  },
  computed: {
    isLoading() {
      return {
        "c-progress-bar--isloading": this.currentValue < this.totalValue,
      };
    },
    progress() {
      return `width: ${(this.currentValue / this.totalValue) * 100}%`;
    },
    completeProgress() {
      if (!this.totalValue || !this.currentValue) return 0;
      return `${((this.currentValue / this.totalValue)*100).toFixed(2)}`;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/progress-bar";
</style>